import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconLogout } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../../global-config'
import { urlResolverGetLogout } from '../../../../../../url-handling'

export const HeaderLogoutButton: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <form
      action={urlResolverGetLogout(globalConfig)}
      className="mt-4"
      method="post"
    >
      <Button
        className="w-full"
        data-qa-id="form-Menubar.Logout"
        endIcon={<IconLogout />}
        size="large"
        type="submit"
        variant="filled"
      >
        <FormattedMessage id="general.link.label.logout" />
      </Button>
    </form>
  )
}
